import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pnc_ic_payment",
  "use": "icon-pnc_ic_payment-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-pnc_ic_payment\"><clipPath id=\"icon-pnc_ic_payment_a\"><path d=\"m0 0h24v24h-24z\" /></clipPath><g clip-path=\"url(#icon-pnc_ic_payment_a)\"><path d=\"m6.94 19h14.06c.55 0 1-.45 1-1v-8.66c-1.65-2.04-4.17-3.34-7-3.34-4.97 0-9 4.03-9 9 0 1.44.34 2.8.94 4z\" fill=\"#d1f0c5\" fill-rule=\"evenodd\" /><g fill=\"#1a1a1a\"><path d=\"m21 20h-18c-1.1 0-2-.9-2-2v-12c0-1.1.9-2 2-2h18c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2zm0-2v1-1s0 0 0 0zm-18-12v12h18v-12s-18 0-18 0z\" /><path d=\"m21 10h-18c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1z\" /><path d=\"m14.62 17.26c-.35 0-.68-.14-.92-.38l-1.97-1.97c-.39-.39-.39-1.02 0-1.41s1.02-.39 1.41 0l1.48 1.48 3.67-3.68c.39-.39 1.03-.39 1.41 0 .39.39.39 1.02 0 1.41l-4.16 4.17c-.25.25-.58.38-.92.38z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pnc_ic_payment.svg
// module id = Awa1
// module chunks = 87